/**
 *
 * @param objectArray - array of objects
 * @param key - the group by the key's value
 */
export function countObjectsByKey(objectArray, key) {
  let counts = {};
  for (const obj of objectArray) {
    const value = obj[key];

    if (counts[value] === undefined) {
      counts[value] = 1;
    } else {
      counts[value]++;
    }
  }
  return counts;
}
